import { render } from "./ListLotto.vue?vue&type=template&id=f4687224"
import script from "./ListLotto.vue?vue&type=script&lang=js"
export * from "./ListLotto.vue?vue&type=script&lang=js"

import "./ListLotto.vue?vue&type=style&index=0&id=f4687224&scope=true&lang=css"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__